'use client';

import BeholdWidget from '@behold/react';

export default function BeholdFeed() {
  return <BeholdWidget feedId="GfKz9tBhGrPV0b5qzKap" />;
}
